import { FC, useCallback } from 'react';
import Tooltip from 'rc-tooltip';
import { SvgIcon } from '@/components';
import './status-tag.less';
import { apiService } from '@/shared/apiService';
import { useImmer } from 'use-immer';
import { ImplListRespItem, ApprovalDetailResp, WidgetInfo } from '@/shared';
import { stateOption } from '../const';
interface StatusTagProps {
  info?: WidgetInfo;
  isRed: boolean;
  statusClassName: string;
  statusName: string;
}

type ReasonListKey = keyof ApprovalDetailResp;

const StatusTag: FC<StatusTagProps> = ({
  info = {} as WidgetInfo,
  isRed = false,
  statusClassName = '',
  statusName = '',
}) => {
  const statusDesc = info.statusDesc || ({} as ImplListRespItem);
  const rejectReason = info.rejects[0];
  return isRed ? (
    <>
      {statusClassName === 'tokeoff' ? (
        <div className={`status-tag-div flex-center ${statusClassName}`}>
          <span
            style={{
              paddingRight: '5px',
              position: 'relative',
              top: '1px',
            }}
          >
            {statusName}
          </span>
        </div>
      ) : (
        <Tooltip
          placement="top"
          // onVisibleChange={(visible: boolean) => {
          //   if (visible) {
          //     if (statusClassName === 'unpass') {
          //       getApprovalDetailFn();
          //     }
          //   }
          // }}
          overlay={
            <div className="app-detail-widget-list-unpass-Tooltip-div">
              {/* {statusClassName === 'tokeoff' && ( // 被运营下线
                <>
                  {rejectReason.reason && (
                    <>
                      <p className="p-title">处理结果：</p>
                      <p className="p-content">{rejectReason.reason}</p>
                    </>
                  )}
                  {statusDesc.amendments && (
                    <>
                      <p className="p-title">温馨提示：</p>
                      <p className="p-content">{statusDesc.amendments}</p>
                    </>
                  )}
                </>
              )} */}
              {statusClassName === 'unpass' && ( // 审核未通过
                <>
                  {/* <p className="p-title">审核状态：</p>
                  <p className="p-content">
                    {stateOption.get(rejectReason.state)}
                  </p> */}
                  <p className="p-title">{window.trans('review-result')}:</p>
                  <p className="p-content">{rejectReason && rejectReason.reason}</p>
                  <p className="p-title">{window.trans('review-tips')}:</p>
                  <p className="p-content">{rejectReason && rejectReason.remark}</p>
                  {/* <p className="p-title">{window.trans('appendix')}</p>
                  <p>
                    <SvgIcon
                      style={{ fill: '#0073DD' }}
                      name="download"
                      width="24"
                      height="24"
                    />
                    <a
                      rel="noreferrer"
                      className="mag-link"
                      download
                      href={rejectReason.fileUrl}
                    >
                      问题反馈
                    </a>
                  </p> */}
                </>
              )}
            </div>
          }
        >
          <div className={`status-tag-div flex-center ${statusClassName}`}>
            <span
              style={{
                paddingRight: '5px',
                position: 'relative',
                top: '1px',
              }}
            >
              {statusName}
            </span>
            <SvgIcon
              style={{ fill: '#FAE6E6' }}
              name="error"
              width="15"
              height="15"
            />
          </div>
        </Tooltip>
      )}
    </>
  ) : (
    <div className={`status-tag-div ${statusClassName}`}>
      <span>{statusName}</span>
    </div>
  );
};
export default StatusTag;
